import { render } from "./Nettiquette.vue?vue&type=template&id=15b2ec26"
import script from "./Nettiquette.vue?vue&type=script&lang=js"
export * from "./Nettiquette.vue?vue&type=script&lang=js"

import "./Nettiquette.vue?vue&type=style&index=0&id=15b2ec26&lang=css"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__